import { SearchMode } from 'model/Filters';
import getAssignedVariant, { setAssignedVariant } from 'utils/abTesting';
import { getExperimentByName } from 'utils/abTests';

function dateFilterOn(filters) {
  return filters.some(({ uid, value }) => uid.startsWith('date.') && !!value);
}

const getSearchPagePrefix = (searchMode, isComingSoonCity, forceOverviewPageVariant, activeFilters = []) => {
  if (searchMode === SearchMode.LANDING_PAGE) {
    return 'experiences';
  }

  if (isComingSoonCity) {
    return searchMode === SearchMode.LOCALS ? 'locals' : 'experiences';
  }

  const isMobile = window.innerWidth < 768;
  if (isMobile && !dateFilterOn(activeFilters)) {
    const overviewPage = getExperimentByName('overviewPage');
    if (forceOverviewPageVariant && searchMode === SearchMode.ALL) {
      setAssignedVariant(overviewPage.id, 1);
      return 'overview';
    }
    if (searchMode === SearchMode.ALL &&
      getAssignedVariant(overviewPage.id, overviewPage.variants.length) === 1) {
      return 'overview';
    }
  }

  return searchMode === SearchMode.LOCALS ? 'l' : 's';
};

export default getSearchPagePrefix;
